<template>
  <div>
    <label style="display: flex; position: relative; align-items: center">
      <vs-input class="w-full h-full" style="border-radius: 5px;" :value="selectCompany ? selectCompany.com_name : selectCompanyName" @click="handleClickInput"/>
      <vs-icon icon-pack="feather" icon="icon-home"
               style="padding-left:6px; padding-right:6px; position: absolute; top:auto; right:0; bottom:auto; font-size:24px; border-left: 1px solid #cdcdcd;"
      ></vs-icon>
    </label>

    <popup-search-company v-model="showPopup"  :selectId="selectCompany ? selectCompany.id : selectCompanyId" @handleClickSelect="handleClickSelect"/>
  </div>
</template>

<script>
import PopupSearchCompany from '@/views/components/popup/PopupSearchCompany'

export default {
  name: 'CompanySelector',
  components: {PopupSearchCompany},
  props:{
    value:[Number, String],
    useName: Boolean
  },
  watch: {
    value (data) {
      this.value = data
    }
  },
  computed: {
    selectCompany () {
      const list = this.$store.state.company.companyList
      for (const company of list) {
        if (company.id === this.value) {
          return company
        }
      }
      return {}
    }
  },
  data () {
    return {
      showPopup:false,
      selectCompanyName: '',
      selectCompanyId:''
    }
  },
  created () {
  },
  methods:{
    handleClickInput () {
      this.showPopup = true
    },

    handleClickSelect (company) {
      this.selectCompanyName = company.com_name
      this.selectCompanyId = company.id
      if (this.useName) {
        this.$emit('input', company.com_name)
      } else {
        this.$emit('input', company.id)
      }
      this.$emit('select', company)
    }
  }
}
</script>

<style scoped>

</style>
